import React, {Component} from 'react';
import moment from 'moment';
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import GridList from 'material-ui/GridList';
import Subheader from 'material-ui/Subheader';
import { GridTile } from 'material-ui/GridList';
import Loading from './Loading';
import { apiService } from '../common/apiCallService';
import fileDownload from 'react-file-download';
import { baseUrl,domain } from '../common/config';
import './DownloadFailedHands.css';


class DownloadFailedHands extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: null,
            date: new Date()
        }

        this.onChangeDate = this.onChangeDate.bind(this);
        this.downloadHands = this.downloadHands.bind(this);
    }

    onChangeDate = (_, date) => {
        this.setState({date})
    }

    downloadHands = (e) => {
        e.preventDefault();
        const reqDate = moment(this.state.date).startOf('day');
        
        this.setState({loading: true, error:null})
        console.log("downloading...")
        apiService(`${baseUrl}/handHistory/downloads`, {
            fromDate: reqDate.format("YYYY-MM-DD"),
            toDate: reqDate.add("day", 1).format("YYYY-MM-DD"),
            accountName: localStorage.getItem("accountName"),
            accountNames: localStorage.getItem("accountNames"),
            type: "failedHands"
        }, (data) => {
            data=JSON.parse(data);
            if (data && data.list !== []) {
                this.setState({loading: false})
                var hands = new Array()
                var downloadHandHistory = `${moment(reqDate).format("YYYY-MM-DD").replace(/\-/g, "")}_${JSON.parse(localStorage.getItem("userRole")).includes("SYS_ADMIN")? localStorage.getItem("currentPlayerAlias"): localStorage.getItem("alias") }.txt`
                for (var i = 0; i < data.list.length; i++) {
                    hands.push(`${data.list[i].handHistory.replace(/#\*#Cashout offered to [^#]*/, "").replace(/#\*#/g, "\r\n")}\r\n\r\n`);
                }
                fileDownload(hands.join(""), downloadHandHistory)
            } else {
                // if(data.status === 403) {
                //     localStorage.setItem("pathName", this.props.location.pathname)
                //     this.setState({loginRedirect: true})
                // }
                this.setState({
                    loading: false,
                    error: "No Data Found"
                })
            }
        }, (err) => {
            console.log(err)
            if(err.status === 400 ){
                if(err.responseJSON.errorCode === 1 || err.responseJSON.errorCode === 2){
                    this.setState({error: err.responseJSON.msg })
                } 
            }
            this.setState({loading: false})
           
        })
    }
    
    
    render() {

        return (
            <div className='background_retry_hands flex-container'style={{ backgroundImage: `url(https://${domain}/images/skillLevel/skill_level_bg_${localStorage.getItem("loggedInType") === "Danskespil" ? "Danskespil" : "PartyPoker"}.jpg)` }}>
            <div className='root_retry_hands' >

                <GridList  className='grid_retry_hands' style={{ marginTop: '120px' }}>
                    <Subheader  className='header_retry_hands' style={{fontSize: '14px', fontWeight: '1000', padding: '8px', color: 'white' }}>DOWNLOAD FAILED HANDS</Subheader>
                    <GridTile>
                        <form onSubmit={this.downloadHands}>
                           <br/> <p style={{margin:'0 0 -10px'}}>Date </p>
                            <DatePicker
                                hintText="Please select Date"
                                hintStyle={{color:'red'}}
                                autoOk={false}
                                disableYearSelection={true}
                                onChange={this.onChangeDate}
                                value={this.state.date}
                                inputStyle={{color: "black"}} 
                                />
                            <button type='submit' fullWidth={true} style={{ backgroundColor: '#e8480d', height: '40px', width: "180px", marginLeft: '23px', color: 'white', borderColor: '#e8480d', fontWeight:'bold' }} >Download Hands</button>
                            
                        </form>
                        {this.state.error!=null? <p style={{marginTop:"10px", color:'red'}}>{this.state.error}</p>: null}
                    </GridTile>
                  
                </GridList>
                {this.state.loading
                ? <Loading/>
                : null}
            </div>
            </div>
        )
    }
}

export default DownloadFailedHands;



/** WEBPACK FOOTER **
 ** ./src/components/DownloadFailedHands.js
 **/